import axios from 'axios';
import { saveAs } from 'file-saver';

export const COHORT_MARKOV_METRIC_ROAS = 'roas';
export const COHORT_MARKOV_METRIC_REVENUE = 'revenue';

async function errorMessageFromBlobResponse(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    const text = await data.text();
    try {
      const json = JSON.parse(text);
      return json.error || text;
    } catch {
      return text || error.message;
    }
  }
  return error?.response?.data?.error || error?.message || 'Request failed';
}

export const downloadCohortMarkovSampleApi = async (
  metric = COHORT_MARKOV_METRIC_ROAS
) => {
  const response = await axios.get('admin/tooling/cohort-markov-fill/sample', {
    responseType: 'blob',
    params: { metric },
  });
  const suffix = metric === COHORT_MARKOV_METRIC_REVENUE ? 'revenue' : 'roas';
  saveAs(response.data, `cohort-markov-fill-template-${suffix}.xlsx`);
};

export const cohortMarkovFillApi = async (file, metric) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('metric', metric);

  const isCsv = file.name.toLowerCase().endsWith('.csv');
  const response = await axios.post(
    'admin/tooling/cohort-markov-fill',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
      params: isCsv ? { format: 'csv', metric } : { metric },
    }
  );

  const contentDisposition = response.headers['content-disposition'] || '';
  const match = /filename="?([^"]+)"?/.exec(contentDisposition);
  const downloadName =
    match?.[1] ||
    (isCsv
      ? file.name.replace(/\.csv$/i, '-filled.csv')
      : file.name.replace(/\.xlsx?$/i, '-filled.xlsx'));

  saveAs(response.data, downloadName);
  return downloadName;
};

export const cohortMarkovFillErrorMessage = errorMessageFromBlobResponse;
